import { render } from "./modal-list-topup-history.vue?vue&type=template&id=d06d23c4&ts=true"
import script from "./modal-list-topup-history.vue?vue&type=script&lang=ts"
export * from "./modal-list-topup-history.vue?vue&type=script&lang=ts"

import "./modal-list-topup-history.vue?vue&type=style&index=0&id=d06d23c4&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__